module.exports = __webpack_public_path__ + "static/media/addPhotoIcon.94ad06de.svg";